import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IHearingDate } from 'src/app/classes/hearing-date';
import { PublicService } from 'src/app/services/public.service';

@Component({
  selector: 'app-agenda-lookup',
  templateUrl: './agenda-lookup.component.html'
})
export class AgendaLookupComponent implements OnInit {

  hearingList: IHearingDate[];
  cols: any[];
  //
  displayState: any = {
    workingDiv: false,
    gridDiv: false,
  };

  constructor(private publicService: PublicService, private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit() {
    this.cols = [
      { field: 'hearingDate', header: 'Hearing Date' },
      { field: 'hearingTime', header: 'Hearing Time' },
    ];
    this.getHearingList();
  }
  goHome() {
    this.router.navigate(['/home']);
  }
  getHearingList() {
    this.displayState.gridDiv = false;
    this.displayState.workingDiv = true;
    this.hearingList = [];
    this.publicService.doAudit('getting list of hearing dates:');
    this.publicService.getHearingDatesForAgenda().subscribe(data => {
      this.publicService.doAudit(data, 'response from getHearingDatesForAgenda');
      this.displayState.workingDiv = false;
      if (data) {
        this.hearingList = data;
        if (data.length < 1) {
          return;
        }
        this.hearingList.sort((a, b) => {
          // @ts-ignore
          return new Date(a.hearingDate) - new Date(b.hearingDate);
        });
      }
      this.displayState.gridDiv = true;
    });
  }

  // generate agenda document for selected hearing date
  onSelect(myHearing: IHearingDate) {
    const id = myHearing.id;
    this.publicService.generateAgenda(id).subscribe(data => {
      this.publicService.doAudit(data, 'response from generateAgenda');
      if (data) {
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
      }
    });
  }
}
